import React, { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { usePopperTooltip } from 'react-popper-tooltip';
import 'react-popper-tooltip/dist/styles.css';
import Select, { components as rsComponents } from 'src/components/ui/BrandSelect';
import { RemoveTags } from '../utils/GlobalFunctions';
import { CustomOption } from '../Common/ReusableComponents/Reusable';
import { connect } from 'react-redux';
import { HelpCircle } from 'lucide-react';

const Control = ({ children, ...props }) => {
  const { value, primaryColor, tooltipBackground, tooltipText } = props.selectProps;
  const style = { cursor: 'pointer', display: value?.description ? 'block' : 'none' };

  const { getArrowProps, getTooltipProps, setTooltipRef, setTriggerRef, visible } = usePopperTooltip();

  return (
    <rsComponents.Control {...props}>
      <span style={style} ref={setTriggerRef}>
        <HelpCircle size={16} strokeWidth={1.5} style={{ color: primaryColor }} />
      </span>
      {value && value.description !== null && value.description !== undefined && visible && (
        <div
          ref={setTooltipRef}
          {...getTooltipProps({
            className: 'tooltip-container',
            style: {
              marginLeft: 10,
              marginTop: 10,
              backgroundColor: tooltipBackground,
              color: tooltipText,
              borderRadius: 5,
            },
          })}>
          <div
            {...getArrowProps({
              className: 'tooltip-arrow',
              style: { color: tooltipBackground, left: '-15px', top: '-3px' },
            })}
          />
          <div className='tooltip-body' style={{ color: 'inherit', textAlign: 'justify' }}>
            <ReactMarkdown>{RemoveTags(value.description)}</ReactMarkdown>
          </div>
        </div>
      )}
      {children}
    </rsComponents.Control>
  );
};

/** Wheel events bubble to the page/modal behind portaled menus; stopPropagation lets the list scroll with the mouse wheel. */
const MenuList = (props) => (
  <rsComponents.MenuList
    {...props}
    innerProps={{
      ...props.innerProps,
      onWheel: (e) => {
        props.innerProps?.onWheel?.(e);
        e.stopPropagation();
      },
      onTouchMove: (e) => {
        props.innerProps?.onTouchMove?.(e);
        e.stopPropagation();
      },
    }}
  />
);

const CustomSelectProps = ({
  item,
  name,
  value,
  zIndex,
  options,
  branding,
  onChange,
  components,
  maxMenuHeight,
  editUsageModal,
  usageTypeDetails,
  menuPortalTarget = typeof document !== 'undefined' ? document.body : null,
  menuPosition = 'fixed',
  ...props
}) => {
  const { primaryColor, tooltipBackground, tooltipText } = branding || {};
  const styles = {
    control: (css) => ({ paddingLeft: '1rem' }),
    container: (x) => ({ ...x, zIndex: zIndex ? zIndex : 10 }),
  };

  //Setting default values
  useEffect(() => {
    const { default: defaultValue } = usageTypeDetails?.find((usgDts) => usgDts.type === name) || {};
    const defaultIsListed = options?.some((option) => String(option?.value) === String(defaultValue));
    // Apply the admin default only when it is one of the options for the current cascade step.
    if (!item?.[name] && defaultValue && defaultIsListed && editUsageModal) {
      editUsageModal(defaultValue, { name: name });
    }
  }, [item, name, options, editUsageModal]);

  useEffect(() => {
    if (!item?.[name] && options.length === 1 && name !== 'subentity' && editUsageModal) {
      editUsageModal(options[0].value, { name: name });
    }
  }, [item, name, options, editUsageModal]);

  return (
    <Select
      {...props}
      menuPortalTarget={menuPortalTarget}
      menuPosition={menuPosition}
      maxMenuHeight={maxMenuHeight || 250}
      components={{ Control, MenuList, Option: CustomOption('UsageData'), ...components }}
      isSearchable
      name={name}
      id={`UsageData-${name}`}
      options={options}
      styles={styles}
      value={value}
      onChange={onChange}
      primaryColor={primaryColor}
      tooltipBackground={tooltipBackground}
      tooltipText={tooltipText}
    />
  );
};

const mapStateToProps = (state) => ({
  branding: state?.branding?.colors,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CustomSelectProps);
